import { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { UserData } from '../../types';
import { computeRegionalBreakdown } from '../../lib/metrics';

const COLORS = ['#ef4444', '#3b82f6'];

interface RegionalChartProps {
  users: UserData[];
}

export function RegionalChart({ users }: RegionalChartProps) {
  const data = useMemo(() => {
    const r = computeRegionalBreakdown(users);
    return [
      { name: `Canada (${r.ca.users})`, value: r.ca.messages },
      { name: `US (${r.us.users})`, value: r.us.messages },
    ].filter(d => d.value > 0);
  }, [users]);

  const renderLabel = ({ name, percent }: { name: string; percent: number }) =>
    `${name} ${(percent * 100).toFixed(0)}%`;

  return (
    <div className="chart-card">
      <h3>Regional Split</h3>
      <p className="chart-subtitle">Users and messages by region</p>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={renderLabel}>
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
